<template>
    <div class="ah-page setup-view">
        <UserControls :showIndex="true" />
        <div class="setup-nav">
            <el-steps finish-status="success" align-center :active="activeStep" class="steps">
                <el-step>
                    <template slot="title">
                        <span class="nav-item" @click="$router.push({ name: 'setup-start' })">開始</span>
                    </template>
                </el-step>
                <el-step>
                    <template slot="title">
                        <span class="nav-item" @click="$router.push({ name: 'setup-bank' })">銀行帳戶</span>
                    </template>
                </el-step>
                <el-step>
                    <template slot="title">
                        <span class="nav-item" @click="$router.push({ name: 'setup-statement' })">收支項目</span>
                    </template>
                </el-step>
                <el-step>
                    <template slot="title">
                        <span class="nav-item" @click="$router.push({ name: 'setup-audit' })">審核流程</span>
                    </template>
                </el-step>
                <el-step>
                    <template slot="title">
                        <span class="nav-item" @click="$router.push({ name: 'setup-finish' })">完成</span>
                    </template>
                </el-step>
            </el-steps>
        </div>
        <div class="ah-container">
            <router-view class="child-view"></router-view>
        </div>
    </div>
</template>
<script>
import UserControls from '../dashboard/UserControls.vue';

export default {
    name: 'SetupWrapperView',
    components: {
        UserControls,
    },
    data() {
        return {};
    },
    mounted() {},
    beforeDestroy() {},
    methods: {},

    computed: {
        activeStep() {
            switch (this.$route.name) {
            case 'setup-start':
                return 0;
            case 'setup-bank':
                return 1;
            case 'setup-statement':
                return 2;
            case 'setup-audit':
                return 3;
            case 'setup-finish':
                return 4;
            }
            return 0;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/main.scss";

.setup-view {
    $nav-width: 270px;
    margin-top: 36px;
    height: 100%;

    .setup-nav {
        background-color: #f6f6f6;
        padding: 30px 0;
        margin-bottom: 25px;
    }

    .steps {
        max-width: 750px;
        margin: 0 auto;
    }

    .nav-item {
        cursor: pointer;
    }

    .child-view {
        margin: 0px 0 0 0;
    }

    .init-step-header {
        text-align: center;
        color: #222;
        padding: 30px;
        margin-bottom: 30px;

        .title {
            color: #000;
            font-size: 18pt;
            margin-bottom: 10px;
        }

        .description {
            font-size: 11pt;
            color: #666;
            max-width: 400px;
            margin: 20px auto 0 auto;
        }
    }

    .actions {
        margin-bottom: 30px;
    }

    > .ah-container {
        padding-bottom: 80px;
    }
}
</style>
